export const dashboardApiURL = {
  taskGraph: "/dashboard/task-graph",
  taskCompletionStatus: "/dashboard/task-status",
  taskCompletionStatusOld: "/dashboard/task-status-old",
  getTaskById: "/dashboard/get-task",
  doneTaskOutput: "/dashboard/done-task-output",
  taskAction: "/dashboard/task-action",
};
